import { Stack, Text } from '@chakra-ui/react';

import GoogleMeetsIntegrationForm from './GoogleMeetsIntegrationForm';
import MicrosoftTeamsIntegrationForm from './MicrosoftTeamsIntegrationForm';
import { useAuthStore } from '@/client/services/state/authStore';
import { useTranslation } from 'react-i18next';

export default function IntegrationsForm() {
  const { t } = useTranslation();
  const { authConfig } = useAuthStore();
  const { company } = authConfig;
  const { feature_flags: featureFlags } = company;
  const {
    enable_microsoft_teams_meetings: enableMicrosoftTeamsMeetings,
    enable_google_meets: enableGoogleMeets,
  } = featureFlags;

  return (
    <Stack spacing={4}>
      <Text fontSize="18px" fontWeight={600} color="baseBlack">
        {t('learners.profile.settings.integrations.title')}
      </Text>

      {enableGoogleMeets && <GoogleMeetsIntegrationForm />}

      {enableMicrosoftTeamsMeetings && <MicrosoftTeamsIntegrationForm />}
    </Stack>
  );
}
